import { Td, Text, Tr } from '@chakra-ui/react';
import { InfoVendedor } from './InfoVendedor';

export function ListaInfos({ chamado }) {
  const notShowLinkPdf = {
    Whatsapp: 'Whatsapp',
    Atendimento: 'Atendimento'
  };

  return (
    <Tr key={chamado.id}>
      <Td textAlign="center">{chamado.data_hora}</Td>
      <Td textAlign="center" textTransform="capitalize">
        <InfoVendedor nomeVendedor={chamado.nome_vendedor} codVendedor={chamado.codigo_vendedor} />
      </Td>
      <Td textAlign="center">{chamado.numero_pedido}</Td>

      <Td textAlign="center">{chamado.tipo_orcamento}</Td>
      <Td textAlign="center">
        {notShowLinkPdf[chamado.tipo_orcamento] ? (
          <Text color="gray.500" fontSize="sm">
            Não disponível
          </Text>
        ) : (
          <Text
            as="a"
            href={chamado.link_pdf}
            color="blue.500"
            _hover={{
              filter: 'brightness(.9)'
            }}
            target="_blank">
            Link Pdf
          </Text>
        )}
      </Td>
    </Tr>
  );
}
